import { ROLES } from '@/constants';

const HLB_STAFF_ROLES = [
  ROLES.superAdmin,
  ROLES.techAdmin,
  ROLES.admin,
  ROLES.adminOfficer,
];

/** True for HLB's own people (they see client status and the HLB team). */
export const isHlbStaffRoles = (roles = []) =>
  roles.map((r) => (typeof r === 'string' ? r : r?.key)).some((r) => HLB_STAFF_ROLES.includes(r));
